"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromCandid = void 0;
const userId_1 = require("./userId");
const option_1 = require("./option");
const dateFunctions = __importStar(require("../../utils/dateFunctions"));
function fromCandid(userSummary) {
    return {
        userId: userId_1.fromCandid(userSummary.id),
        username: userSummary.username,
        usernameLower: userSummary.username.toLowerCase(),
        lastOnline: dateFunctions.addSeconds(new Date(), -userSummary.seconds_since_last_online),
        minutesSinceLastOnline: Math.floor(userSummary.seconds_since_last_online / 60),
        imageId: option_1.fromCandid(userSummary.image_id),
        chatId: userSummary.chat_id,
        version: userSummary.version
    };
}
exports.fromCandid = fromCandid;
